import { render } from "./MenuSelect.vue?vue&type=template&id=d6d1f65e&scoped=true"
import script from "./MenuSelect.vue?vue&type=script&lang=js"
export * from "./MenuSelect.vue?vue&type=script&lang=js"

import "./MenuSelect.vue?vue&type=style&index=0&id=d6d1f65e&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6d1f65e"]])

export default __exports__